module.exports = __webpack_public_path__ + "media/images/lb/604-42ad11703984426168bb5afdc082e86b.svg";